module.exports = __webpack_public_path__ + "img/team.9b62a5a4.png";